export default __webpack_public_path__ + "static/media/Slide4.99e9bf38.png";